import { Button, ButtonType } from '@resurs-internal/styx-react'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../common/utils'
import styles from './Mock.module.scss'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

export const ConsentPage = ({ serviceName, servicePath }) => {
  const { token: sessionToken } = useParams()
  const { govId } = useQuery()

  const approveUrl = `${proxyPath}/${servicePath}/consent-page/${sessionToken}/success`
  const rejectUrl = `${proxyPath}/${servicePath}/consent-page/${sessionToken}/failure`

  return (
    <>
      <h1>{serviceName} – Consent</h1>
      <p>Complete or reject this consent request from the mock service.</p>

      <div className={styles.infoSection}>
        <div className={styles.listItem}>
          <span className={styles.label}>Service</span>
          <span>{serviceName}</span>
        </div>
        <div className={styles.listItem}>
          <span className={styles.label}>Session token</span>
          <span className={styles.mono}>{sessionToken}</span>
        </div>
        {govId && (
          <div className={styles.listItem}>
            <span className={styles.label}>Government ID</span>
            <span className={styles.mono}>{govId}</span>
          </div>
        )}
      </div>

      <div className={styles.lineWrapper}>
        <Button
          id="approveBtn"
          fullWidth
          onClick={() => {
            window.location.href = approveUrl
          }}
        >
          Complete Assessment
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="rejectBtn"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => {
            window.location.href = rejectUrl
          }}
        >
          Reject
        </Button>
      </div>
    </>
  )
}
